module.exports = __webpack_public_path__ + "media/images/icons/ico-translation-310ff34bc36000acea4d7c1b3442a8e7.svg";